import React from 'react';
import { FormHelperText, Input } from '@material-ui/core';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import FormTitle from '../../dynamicForms/FormComponents/FormTitle';

interface IFileUploaderProps {
    // venueId: string;
    typeOfFile: string;
    // fileName: string;
    label: string;
    required: boolean;
    onSelect: (typeOfFile: string, file: File) => void;
    onDeSelect?: (typeOfFile: string) => void;
    keyName: string;
    disabled?: boolean;
    hasLine?: boolean;
    onFailedInteraction?: Function;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        Disabled: {
            pointerEvents: 'none',
        },
    }),
);

export const FileUploader = (props: IFileUploaderProps) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const onSelected = (event: any) => {
        const file = event.target.files[0];
        props.onSelect(props.typeOfFile, file);
        if (props.onDeSelect) {
            props.onDeSelect(props.typeOfFile);
        }
    };
    return (
        <>
            <FormTitle title={props.label} hasLine={props.hasLine} />
            <div
                onClick={() => {
                    if (props.disabled) {
                        props?.onFailedInteraction?.();
                    }
                }}
            >
                <div className={props.disabled ? classes.Disabled : ''}>
                    <Input
                        data-id={`${props.typeOfFile}-fileUploader`}
                        type="file"
                        onChange={onSelected}
                        name={props.keyName}
                        inputProps={{ accept: 'image/jpeg, image/jpg, image/png' }}
                        required={props.required}
                        aria-describedby="file-upload-helper"
                    />
                </div>
            </div>
            <FormHelperText id="file-upload-helper">{t('errors.formHelperText.images')}</FormHelperText>
        </>
    );
};

export default FileUploader;
